import { createReducer, Action, on } from '@ngrx/store';

import { LabelActions } from './label.actions';
import { LabelState } from './label.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { AppActions } from '../app/app.actions';

export const initialState: LabelState = {
  labels: null,
  defaultLabelIds: null,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      AppActions.LoadInitDataSuccess,
      (state, action): LabelState => ({
        ...state,
        defaultLabelIds: action.data.userSettings.defaultLabelIds,
      })
    ),
    on(
      LabelActions.DownloadLabelsSuccess,
      (state, action): LabelState => ({ ...state, labels: action.labels })
    ),
    on(
      LabelActions.SetDefaultLabelsSuccess,
      (state, action): LabelState => ({ ...state, defaultLabelIds: action.labelIds })
    )
  )
);

export function reducer(state: LabelState | undefined, action: Action) {
  return featureReducer(state, action);
}
